/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    POST_AI_REVIEW_VOTE_FAILURE,
    POST_AI_REVIEW_VOTE_START,
    POST_AI_REVIEW_VOTE_SUCCESS,
} from '../constants/types';
import { makeAsyncReducer } from '../utils/async_utils';

export const postAIReviewVote = makeAsyncReducer(
    {
        startType: POST_AI_REVIEW_VOTE_START,
        successType: POST_AI_REVIEW_VOTE_SUCCESS,
        failureType: POST_AI_REVIEW_VOTE_FAILURE,
    },
    { initialData: {} }
);

export const postAIReviewVoteSelector = (state) => state.ratingReviews.postAIReviewVote;
